import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const SchoolContactLog = ApplicationRecord.extend({
  static: {
    jsonapiType: 'school_contact_logs',
  },
  attrs: {
    email: attr(),
    createdAt: attr(),
  },
})

export default SchoolContactLog
